"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Cookies = __importStar(require("js-cookie"));
var React = __importStar(require("react"));
var out_of_inventory_form_1 = __importDefault(require("./components/out-of-inventory-form"));
var submit_form_1 = __importDefault(require("./components/submit-form"));
exports.default = (function (props) {
    if (!props) {
        return null;
    }
    var header = props.header, disclaimerHeader = props.disclaimerHeader, signaturePrintImage = props.signaturePrintImage, discountBadge = props.discountBadge, oosBadge = props.oosBadge, endGiveawayBadge = props.endGiveawayBadge, modalHeader = props.modalHeader, modalText = props.modalText, signaturePrintText = props.signaturePrintText, disclaimers = props.disclaimers, freeDiaperProduct = props.freeDiaperProduct, availablePatterns = props.availablePatterns, distributedAmountMeta = props.distributedAmountMeta;
    // Set discount cookie so that discount will automatically be applied at ReCharge Checkout if user is logged in
    if (props.settings.autoDiscountCode) {
        Cookies.set('discount', props.settings.autoDiscountCode);
    }
    var allowablePatterns = props.settings.offeredPatterns.split(',');
    var allowableSizes = props.settings.offeredSizes.split(',');
    var dailyLimitCount = props.settings.dailyLimit;
    var numOfDiapersLeftToGiveAway = !distributedAmountMeta ? dailyLimitCount : dailyLimitCount - distributedAmountMeta;
    var inStock = availablePatterns.filter(function (pattern) { return allowableSizes.includes(pattern.option1) && allowablePatterns.includes(pattern.option2); });
    /*
    * Configuration in CMS should only allow sizes N,1 and Sleepy Sloths,Alphabet Soup. Order and spacing matters
  
    * For size N, only Sleepy Sloths should ever be offered. If we run out of Sleepy Sloths size N, we're OOS for size N
    * For size 1, first offer Sleepy Sloths. If we run out, then offer Alphabet Soup. If we run out of Alphabet Soup, then we're OOS for size 1
    * */
    var _a = __read(inStock.reduce(function (arr, pattern) {
        if (pattern.option1 === 'N') {
            arr[0].push(pattern);
        }
        else if (pattern.option1 === '1') {
            arr[1].push(pattern);
        }
        return arr;
    }, [[], []]), 2), sizeNs = _a[0], size1s = _a[1];
    // ensure only Sleepy Sloths is offered for size N
    var allowedSizeN = sizeNs.filter(function (pattern) { return pattern.option2 === allowablePatterns[0]; });
    // find Sleepy Sloths pattern for size 1
    var firstPatternSize1 = size1s.find(function (pattern) { return pattern.option2 === allowablePatterns[0]; });
    var allowedSize1 = [];
    // if no size 1's are available, then we're OOS for all size1 patterns
    if (size1s.length > 0) {
        // if we're out of Sleepy Sloths pattern for size 1, then offer Alphabet Soup.
        if (firstPatternSize1) {
            allowedSize1.push(firstPatternSize1);
        }
        else {
            allowedSize1.push(size1s[0]);
        }
    }
    var patternOffers = __spreadArray(__spreadArray([], __read(allowedSizeN), false), __read(allowedSize1), false);
    var giveawayIsOOS = patternOffers.length <= 0 || numOfDiapersLeftToGiveAway <= 0 || props.settings.endGiveaway;
    var disclaimerPoints = disclaimers.map(function (disclaimer, i) { return (React.createElement("div", { className: 'grid-x medium-padding-vertical-2', key: i },
        React.createElement("span", { className: 'small-1 medium-padding-vertical-2' }, "+"),
        React.createElement("span", { className: 'small-11 medium-padding-vertical-2', style: { fontWeight: 'lighter' } }, disclaimer))); });
    var inStockPresentation = (React.createElement("div", { className: 'grid-container grid-x padding-vertical-10' },
        React.createElement("div", { className: 'small-12 medium-6 medium-padding-horizontal-3' },
            React.createElement("h3", { className: 'padding-right-20 padding-top-10' }, disclaimerHeader),
            React.createElement("div", { className: 'divider bg-wisteria margin-vertical-5', style: { width: '50px' } }),
            disclaimerPoints,
            React.createElement("div", { className: 'grid-x padding-top-3' },
                React.createElement("div", { className: 'small-6', style: { height: '120px', width: '120px' } },
                    React.createElement("img", { className: 'bordered border-transparent circle display-block overflow-hidden', src: signaturePrintImage, alt: 'signature pattern' })),
                React.createElement("div", { className: 'small-6', style: { margin: 'auto' } }, signaturePrintText))),
        React.createElement("div", { className: 'small-12 medium-6 medium-padding-horizontal-10' },
            React.createElement("div", null,
                React.createElement("div", { className: 'padding-top-10 grid-x' },
                    React.createElement("h3", { className: 'small-7 medium-8' }, header),
                    React.createElement("div", { className: 'small-5 medium-4' },
                        React.createElement("img", { src: discountBadge })),
                    React.createElement(submit_form_1.default, { availablePatterns: patternOffers, promoProduct: freeDiaperProduct, modalHeader: modalHeader, modalText: modalText }))))));
    var outOfStockPresentation = (React.createElement("div", { className: 'grid-container padding-vertical-5 medium-padding-vertical-10 text-center' },
        props.settings.endGiveaway ? (React.createElement("div", { className: 'grid-container' },
            React.createElement("div", { className: 'text-right' },
                React.createElement("img", { src: endGiveawayBadge, className: 'show-for-medium', style: { width: '20%' } }),
                React.createElement("img", { src: endGiveawayBadge, className: 'hide-for-medium', style: { width: '40%' } })),
            React.createElement("h3", { className: 'padding-top-3' }, "We were BLOWN AWAY"),
            React.createElement("div", { className: 'padding-bottom-5' }, "...by the incredible demand for our free diapers!"),
            React.createElement("div", { className: 'padding-bottom-1' }, "We had to close this promotion for now BUT sign up below to receive 15% off your first bundle!"))) : (React.createElement("div", { className: 'grid-container' },
            React.createElement("div", { className: 'text-right' },
                React.createElement("img", { src: oosBadge, className: 'show-for-medium', style: { width: '20%' } }),
                React.createElement("img", { src: oosBadge, className: 'hide-for-medium', style: { width: '40%' } })),
            React.createElement("h3", { className: 'padding-top-3' }, "Whoopsies\u2026we\u2019re all out for today!"),
            React.createElement("div", { className: 'padding-bottom-5' }, "Please supply your name and email address below, and we\u2019ll send you an email when you can sign up again."))),
        React.createElement(out_of_inventory_form_1.default, { modalHeader: modalHeader, modalText: modalText, oosButtonText: props.settings.endGiveaway ? 'Submit' : 'Get Notified' })));
    // hide the bundle offer if we are out of stock for the day
    if (giveawayIsOOS) {
        $(document).ready(function ($) {
            $('.savings-offer').hide();
        });
    }
    return !giveawayIsOOS ? inStockPresentation : outOfStockPresentation;
});
